<template>
  <div class="" style="padding: 0; height: 100%; width: 100%">
    <div
      class=""
      id="ybp3"
      @mouseenter="clearDispatchTimer"
      @mouseleave="setDispatchTimer"
      style="height: 100%; width: 100%"
    ></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-gl";
export default {
  data() {
    return {
      interVal: "",
      myChart: null,
      app: {
        currentIndex: -1,
      },
      dispatchTimer: null,
      dataLen: null,
    };
  },
  mounted() {
    // this.requestData(500)
    this.init();
  },
  methods: {
    requestData(number, area, tulongNum, beforeMoney, afterMoney) {
      this.$request(
        "center/newService1/farmLines?num=" +
          number +
          "&area=" +
          area +
          "&tulongNum=" +
          tulongNum +
          "&beforeMoney=" +
          beforeMoney +
          "&afterMoney=" +
          afterMoney
      ).then((res) => {
        if (this.myChart) {
          clearInterval(this.dispatchTimer);
          this.myChart.clear();
        }
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].type == 1) {
            this.init(res.data[i].list);
          }
        }
      });
    },
    init(pageData, type) {
      let that = this;
      that.myChart = echarts.init(document.getElementById("ybp3"));

      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        that.myChart.resize();
      });

      const colorStyle = [
        [
          1,
          new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            {
              offset: 0,
              color: "rgb(31 78 83 / 20%)",
            },
            {
              offset: 1,
              color: "rgb(48 186 91 / 90%)",
            },
          ]),
        ],
      ];
      var option = {
        series: [
          //最外的圆圈（外层刻度）
          {
            type: "gauge",
            center: ["50%", "55%"],
            radius: "90%",
            startAngle: 220,
            endAngle: -40,
            min: 0,
            max: 100,
            axisLine: {
              show: true,
              lineStyle: {
                width: 3,
                color: colorStyle,
              },
            },
            axisLabel: {
              show: true,
              distance: -16,
              rotate: 0,
              textStyle: {
                color: "rgba(63, 250, 250, 0.8)",
                fontSize: "6",
                fontWeight: "bold",
              },
            },
            axisTick: {
              lineStyle: {
                color: "rgba(63,250,250,0.7)",
                width: 1,
              },
              length: 5,
            },
            splitLine: {
              length: 8,
              lineStyle: {
                color: "rgba(63,250,250,0.8)",
                width: 3,
              },
            },
          },
          // 外围刻度（第二层）
          {
            type: "gauge",
            center: ["50%", "55%"],
            radius: "85%", // 1行3个
            min: 0,
            max: 100,
            startAngle: 220,
            endAngle: -40,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: colorStyle,
                fontSize: 20,
                width: 10,
                opacity: 1, //刻度背景宽度
              },
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          // 外围刻度（中间有背景颜色那块，包括里面的刻度）
          {
            type: "gauge",
            center: ["50%", "55%"],
            radius: "82%", // 1行3个
            splitNumber: 10,
            min: 0,
            max: 100,
            startAngle: 40,
            endAngle: -220,
            //分隔线样式
            axisTick: {
              lineStyle: {
                color: "rgba(63,250,250,0.8)",
                width: 1,
              },
              length: 5,
            },
            //刻度样式
            axisLine: {
              show: false,
              lineStyle: {
                width: 90,
                color: colorStyle,
              },
            },
            //整数分隔线
            splitLine: {
              show: true,
              length: 7,
              lineStyle: {
                color: "rgba(63, 250, 250, 0.8)",
                width: 2,
              },
            },
            //刻度数字
            axisLabel: {
              show: false,
              distance: -20,
              rotate: 0,
              textStyle: {
                color: "rgba(63, 250, 250, 0.8)",
                fontSize: "6",
                fontWeight: "bold",
              },
            },
          },
          //从外数第三条线
          {
            type: "gauge",
            center: ["50%", "55%"],
            radius: "77%", // 1行3个
            splitNumber: 10,
            min: 0,
            max: 100,
            startAngle: 220,
            endAngle: -40,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: colorStyle,
                fontSize: 12,
                width: 2,
                opacity: 1, //刻度背景宽度
              },
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: 0,
            },
          },
          {
            type: "gauge",
            center: ["50%", "55%"],
            radius: "112%", // 1行3个
            splitNumber: 10,
            min: 0,
            max: 100,
            startAngle: 220,
            endAngle: -40,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: colorStyle,
                fontSize: 12,
                width: 2,
                opacity: 1, //刻度背景宽度
              },
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            detail: {
              show: 0,
            },
          },
          // 内侧指针、数值显示
          {
            name: "",
            center: ["50%", "50%"],
            type: "gauge",
            radius: "74%", // 1行3个
            splitNumber: 10,
            min: 0,
            max: 100,
            startAngle: 220,
            endAngle: -40,
            axisLine: {
              show: true,
              lineStyle: {
                width: 50,
                color: [
                  [
                    1,
                    new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: "rgba(0, 199, 187, 0)",
                      },
                      {
                        offset: 1,
                        color: "rgba(0, 199, 187, 0)",
                      },
                    ]),
                  ],
                ],
              },
            },
            axisTick: {
              show: 0,
            },
            splitLine: {
              show: 0,
            },
            axisLabel: {
              show: false,
            },
            pointer: {
              show: true,
              length: "107%",
              width: 4,
              itemStyle: {
                color: 'rgb(48 186 91 / 90%)',
              },
            },
            data: [
              {
                value: 60,
                name: "m³/天",
                title: {
                  offsetCenter: ["0%", "85%"],
                  fontSize: 12,
                  color: "#4fe8d6",
                },
                detail: {
                  offsetCenter: ["0%", "50%"],
                  valueAnimation: true,
                  fontSize: 16,
                  color: "#4fe8d6",
                },
              },
            ],
          },
        ],
      };

      //   that.dataLen = option.series[0].data.length;
      that.dispatchActions();

      that.myChart.setOption(option);
      //   this.interVal = setInterval(function () {
      //     that.myChart.clear();
      //     that.myChart.setOption(option);
      //   }, 240000);
      // 20000
    },
    dispatchActions() {
      let that = this;
      that.dispatchTimer = setInterval(function () {
        // 取消之前高亮的图形
        that.myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        that.app.currentIndex = (that.app.currentIndex + 1) % that.dataLen;
        //console.log(app.currentIndex);
        // 高亮当前图形
        that.myChart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
        // 显示 tooltip
        that.myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: that.app.currentIndex,
        });
      }, 3000);
    },
    clearDispatchTimer() {
      clearInterval(this.dispatchTimer);
    },
    setDispatchTimer() {
      this.dispatchActions();
    },
  },
  destroyed() {
    clearInterval(this.interVal);
  },
};
</script>

<style>
</style>